function removeEmptyProductBlocks(root = document) {
  root.querySelectorAll(".product-block").forEach(function (el) {
    const hasText = el.textContent.trim().length > 0;
    const hasImportantChildren = el.querySelector(
      "img, video, iframe, svg, canvas, input, select, textarea, button, a, hr, audio, object, embed, picture, source, track, map, area, details, summary, meter, progress",
    );

    if (!hasText && !hasImportantChildren) {
      el.remove();
    }
  });
}

function initStickyAddToCart(root = document) {
  root.querySelectorAll("[data-sticky-atc]").forEach(function (bar) {
    if (bar.dataset.stickyAtcInit) return;
    bar.dataset.stickyAtcInit = "true";

    var container = bar.closest('[data-section-type="product"]');
    var form = document.getElementById(bar.dataset.targetForm);
    var targetButton = form ? form.querySelector("[data-add-to-cart]") : null;

    var priceEl = bar.querySelector("[data-sticky-atc-price]");
    var buttonEl = bar.querySelector("[data-sticky-atc-button]");
    var buttonTextEl = bar.querySelector("[data-sticky-atc-button-text]");

    if (buttonEl && targetButton) {
      buttonEl.addEventListener("click", function () {
        targetButton.click();
      });
    }

    if (container) {
      container.addEventListener("variantChange", function (event) {
        var variant = event.detail.variant;

        if (priceEl && variant) {
          priceEl.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
        }

        if (!buttonEl) return;

        if (variant && variant.available) {
          buttonEl.disabled = false;
          if (buttonTextEl) buttonTextEl.textContent = buttonTextEl.dataset.defaultText;
        } else if (variant) {
          buttonEl.disabled = true;
          if (buttonTextEl) buttonTextEl.textContent = theme.strings.soldOut;
        } else {
          buttonEl.disabled = true;
          if (buttonTextEl) buttonTextEl.textContent = theme.strings.unavailable;
        }
      });
    }

    if (!targetButton || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle("sticky-add-to-cart--visible", scrolledPast);
        });
      },
      { threshold: 0 },
    );

    observer.observe(targetButton);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  removeEmptyProductBlocks();
  initStickyAddToCart();
});

document.addEventListener("shopify:section:load", function (event) {
  removeEmptyProductBlocks(event.target);
  initStickyAddToCart(event.target);
});
